import { UsualPower } from '@/services/api/usual-power/usual-power'

export type UsualPowerComparisonResult =
  | SameUsualPowerComparisonResult
  | DifferentUsualPowerComparisonResult

export interface SameUsualPowerComparisonResult {
  result: 'same'
  sameType: 'left-only' | 'right-only' | 'both'
}

export interface DifferentUsualPowerComparisonResult {
  result: 'different'
}

/**
 * コンタクトレンズアイテムの度数と「いつもの度数」との比較
 */
export function compareUsualPower(
  usualPowerInfo: Pick<UsualPower, 'leftPathname' | 'rightPathname'> | null,
  itemPowerPathname: string | null
): UsualPowerComparisonResult | null {
  if (!usualPowerInfo || !itemPowerPathname) {
    return null
  }

  const { leftPathname, rightPathname } = usualPowerInfo

  // 両目とも未登録の場合は何も表示しない
  if (!leftPathname && !rightPathname) {
    return null
  }

  const leftMatches = leftPathname && itemPowerPathname === leftPathname
  const rightMatches = rightPathname && itemPowerPathname === rightPathname

  // 両目とも一致
  if (leftMatches && rightMatches) {
    return { result: 'same', sameType: 'both' }
  }

  // 左目のみ一致
  if (leftMatches) {
    return { result: 'same', sameType: 'left-only' }
  }

  // 右目のみ一致
  if (rightMatches) {
    return { result: 'same', sameType: 'right-only' }
  }

  // 両目とも不一致
  return { result: 'different' }
}
